// src/components/Finanzas/FinanzasPage.jsx
// Finanzas module shell: access guard + sub-tab bar.
// Access comes from App.js's PERMISSIONS matrix (canViewFinanzas), never from user.role here.

import React, { useState } from 'react';
import ManifiestoTab from './subtabs/ManifiestoTab';
import MesTab from './subtabs/MesTab';
import './Finanzas.css';

const SUBTABS = [
  { key: 'manifiesto', label: 'Manifiesto' },
  { key: 'mes',        label: 'Mes' },
  { key: 'historico',  label: 'Histórico' },
];

const FinanzasPage = ({ userPermissions }) => {
  const [subtab, setSubtab] = useState('manifiesto');

  if (!userPermissions?.canViewFinanzas) {
    return (
      <div className="fin-page">
        <div className="fin-banner fin-banner--warn">No tenés acceso a Finanzas.</div>
      </div>
    );
  }

  return (
    <div className="fin-page">
      <header className="fin-header">
        <h2>Finanzas</h2>
        <p>Cobertura por manifiesto, cierre mensual y análisis por operador</p>
      </header>

      <nav className="fin-subtabs" role="tablist" aria-label="Secciones de Finanzas">
        {SUBTABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={subtab === t.key}
            className={`fin-subtab ${subtab === t.key ? 'is-active' : ''}`}
            onClick={() => setSubtab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {subtab === 'manifiesto' && <ManifiestoTab />}
      {subtab === 'mes' && <MesTab />}
      {subtab === 'historico' && <div className="fin-placeholder">Próximamente</div>}
    </div>
  );
};

export default FinanzasPage;
